import React from "react";
import VisDiv from "../../../whitaijiFrontendLibrary/components/VisDiv";
import BlueButton from "../../BlueButton";
import { CiCircleCheck } from "react-icons/ci";
import { HiCheckCircle } from "react-icons/hi2";

export const CheckButton = ({children, data={}}) => {

    const { answerId, userResponse, answerText, setUserResponse, question, doc, setDoc } = data
    const questionId = question?.questionId
    const updateDoc = (doc={}, newAnswerDoc={}) => {
        const existingAnswers = !doc?.userResponses ? [] : doc?.userResponses
/*         if(!doc) {
            process.env.NODE_ENV === "development" && console.log("doc does not exist", doc)
            return ({userResponses:[newAnswerDoc]})} */
        const newDoc = {...doc, userResponses:[...existingAnswers?.filter((x)=>x?.questionId !== newAnswerDoc?.questionId), newAnswerDoc]}
       //process.env.NODE_ENV === "development" && console.log("existingAnswers", existingAnswers, newDoc)
        return newDoc
    }
    const answerFn = () => {
        const findExistingAnswers = !doc?.userResponses ? [] : doc?.userResponses?.find((x)=>x?.questionId === questionId)?.answers
        const existingAnswers = findExistingAnswers ? [...findExistingAnswers] : []
        const answerDocExists = existingAnswers?.some((x)=>x?.answerId === answerId)
        const answerDoc = {answerText, answerId}
      
        
        const newAnswerDoc = () => {
            if(answerDocExists) { return ( {questionId, answers:[...existingAnswers?.filter((x)=>x?.answerId !== answerId) ]} )}
            return ( {questionId, answers:[...existingAnswers, answerDoc]} )
        } 
        process.env.NODE_ENV === "development" && console.log("existingAnswers", newAnswerDoc(), answerDocExists)
        //process.env.NODE_ENV === "development" && console.log("userResponse", newAnswerDoc, question)
        setUserResponse(newAnswerDoc())
        setDoc(updateDoc(doc, newAnswerDoc()))
      
    }

    const testFunction = (e) => {
        e.stopPropagation()
        process.env.NODE_ENV === "development" && console.log("wkemelkwmxc", "userResponse", userResponse, "answerId", answerId, "questionId", questionId)
    }
    return (
        <div onClick={answerFn} className="radio-button-container">
            <VisDiv>
                <VisDiv className="flex-center" rules={[!userResponse?.answers?.some((x)=>x?.answerId === answerId)]}>
                    <CiCircleCheck size={24} />
                </VisDiv>  
                <VisDiv className="flex-center"rules={[userResponse?.answers?.some((x)=>x?.answerId === answerId)]}>
                    <HiCheckCircle size={24} />
                </VisDiv>  
            </VisDiv>
            
            <div className="margin-left flex-center">
                <p>{children}</p>
            </div>
            <div className="margin-left flex-center">
                <BlueButton hide={true} margins={false} fn = {testFunction}/>
            </div>
          
        </div>
    );
}   